<template>
  <div class="lang-select hidden-md-and-down">
    <el-dropdown @command="handleSetLanguage">
      <span class="el-dropdown-link">
        <i class="icon icon-language"></i>
        {{local}}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh_CN">{{ $t('中文') }}</el-dropdown-item>
        <el-dropdown-item command="en">{{ $t('English') }}</el-dropdown-item>
        <el-dropdown-item command="ms">{{ $t('Malaysia') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
export default {
	name: 'lang-select',
	data() {
		return {
			langs: {
				cn: '中文',
				en: 'English'
			}
		};
	},
	computed: {
		...mapGetters(['lang', 'roleId']),
		local() {
			let local = this.langs[this.lang];
			return local;
		}
	},
	methods: {
		...mapMutations({
			selectLangs: 'SELECT_LANGS'
		}),
		...mapActions(['getMenuMap']),
		/**
		 * 选择语言
		 */
		handleSetLanguage(lang) {
			this.$i18n.locale = lang;
			this.selectLangs({
				lang
			});
			this.getMenuMap({ role_id: this.roleId, lang })
				.then(res => {
          window.location.reload();
					console.log('select lang', res);
				})
				.catch(err => {
					console.error('select lang', err);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.lang-select {
	padding-left: 15px;
	color: $-color-text-primary;
	i {
		cursor: pointer;
	}
}
</style>
